/**
 * @generated SignedSource<<bcfcd60201a4c33614201292f24a04aa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RedeemBanner_balance$data = {
  readonly amount: {
    readonly formatted: string;
    readonly subUnitAmount: number;
  };
  readonly id: string;
  readonly " $fragmentType": "RedeemBanner_balance";
};
export type RedeemBanner_balance$key = {
  readonly " $data"?: RedeemBanner_balance$data;
  readonly " $fragmentSpreads": FragmentRefs<"RedeemBanner_balance">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./RedeemBannerBalanceRefetchQuery.graphql'),
      "identifierField": "id"
    }
  },
  "name": "RedeemBanner_balance",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CurrencyAmount",
      "kind": "LinkedField",
      "name": "amount",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "formatted",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "subUnitAmount",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "WalletBalance",
  "abstractKey": null
};

(node as any).hash = "81b00572b4fd7013c62281d5f96bcb8b";

export default node;
